import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../icon';
import Menu from '../menu';
import ConfigProvider from '../config-provider';
import Item from './item';
import Overlay from '../overlay';
const { Popup } = Overlay;

/**
 * Breadcrumb
 */
class Breadcrumb extends Component {
  static Item = Item;

  static propTypes = {
    /**
     * 样式类名的品牌前缀
     */
    prefix: PropTypes.string,
    rtl: PropTypes.bool,
    /*eslint-disable*/
    /**
     * 面包屑子节点，需传入 Breadcrumb.Item
     */
    children: (props, propName) => {
      Children.forEach(props[propName], child => {
        if (
          !(child && typeof child.type === 'function' && child.type._typeMark === 'breadcrumb_item')
        ) {
          throw new Error("Breadcrumb's children must be Breadcrumb.Item!");
        }
      });
    },
    /*eslint-enable*/
    /**
     * 面包屑最多显示个数，超出部分会被隐藏
     */
    maxNode: PropTypes.number,
    /**
     * 分隔符，可以是文本或 Icon
     */
    separator: PropTypes.node,
    /**
     * 设置标签类型
     */
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    className: PropTypes.any,
  };

  static defaultProps = {
    prefix: 'next-',
    maxNode: 4,
    separator: <Icon type="chevron-right-s" />,
    component: 'nav',
  };

  render() {
    const {
      prefix,
      rtl,
      className,
      maxNode,
      children,
      separator,
      component,
      ...others
    } = this.props;
    // const clazz = classNames(``, className);
    let items;
    let menuItems = [];
    const length = Children.count(children);

    if (maxNode > 1 && length > maxNode) {
      const breakpointer = length - 3;
      items = [];

      // 用 for 循环替代 forEach，可以用 continue
      for (let i = 0; i < length; i++) {
        const ariaProps = {};
        let item = children[i];
        if (i === length - 1) {
          // push 最后一项，不带 separator
          ariaProps['aria-current'] = 'page';
          items.push(
            React.cloneElement(item, {
              prefix,
              key: i,
              ...ariaProps,
              className: `${prefix}breadcrumb-menu-item`,
              activated: i === length - 1,
            }),
          );
        }

        if (i === 0) {
          items.push(
            // push 第一项
            React.cloneElement(item, {
              prefix,
              separator,
              key: i,
              ...ariaProps,
            }),
          );
          continue;
        }

        if (i === breakpointer) {
          // 把当前项存进去
          menuItems.push(
            React.cloneElement(item, {
              key: i,
              ...ariaProps,
            }),
          );
          // push ...
          items.push(
            React.cloneElement(
              item,
              {
                separator,
                prefix,
                key: i,
                href:'javascript:void(0)', //不跳转
                activated: i === length - 1,
                ...ariaProps,
                className: `${prefix}breadcrumb-show-more`,
              },
              <Popup
                trigger={<Icon type="more" />}
                triggerType="click"
                align="tc bl"
                offset={[0, 4]}
              >
                <Menu>
                  {menuItems.map((menuItem, key) => {
                    if (menuItem.props.link) {
                      return (
                        <Menu.Item key={key}>
                          <a href={menuItem.props.link}>
                            {menuItem.props.children}
                          </a>
                        </Menu.Item>
                      );
                    } else {
                      return <Menu.Item key={key}>{menuItem.props.children}</Menu.Item>;
                    }
                  })}
                </Menu>
              </Popup>,
            ),
          );
        } else if (i === length - 2) {
          // push 倒数第二项
          items.push(
            React.cloneElement(item, {
              separator,
              prefix,
              key: i,
              ...ariaProps,
            }),
          );
        } else {
          // push 到 menuItems 里面
          menuItems.push(
            React.cloneElement(item, {
              key: i,
              ...ariaProps,
            }),
          );
        }
      }
    } else {
      items = Children.map(children, (item, i) => {
        const ariaProps = {};

        if (i === length - 1) {
          ariaProps['aria-current'] = 'page';
        }

        return React.cloneElement(item, {
          separator,
          prefix,
          activated: i === length - 1,
          ...ariaProps,
          key: i,
        });
      });
    }

    if (rtl) {
      others.dir = 'rtl';
    }
    const BreadcrumbComponent = component;

    return (
      <BreadcrumbComponent aria-label="Breadcrumb" className={className} {...others}>
        <ul className={`${prefix}breadcrumb`}>{items}</ul>
      </BreadcrumbComponent>
    );
  }
}

export default ConfigProvider.config(Breadcrumb);
